import { CopyToClipboard } from "react-copy-to-clipboard";
import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import * as constants from "@redbubble/design-system/react/constants";
import Button from "@redbubble/design-system/react/Button";
import TickIcon from "@redbubble/design-system/react/Icons/Tick";
import ShareIcon from "@redbubble/design-system/react/Icons/Share";
import Tooltip from "@redbubble/design-system/react/Tooltip";
import Text from "@redbubble/design-system/react/Text";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

import { clientError } from "../../lib/errorReporting";

const ShareButton = ({
  logEvent,
  shareTitle,
  shareDescription,
  shareUrl,
  size,
  withText,
}) => {
  const supportsShare =
    typeof window !== "undefined" &&
    typeof get(window, "navigator.share") === "function";

  const getShareFunction = (title, description, url) => {
    return () => {
      if (!supportsShare) {
        return null;
      }

      window.navigator.share({ title, text: description, url }).catch((e) => {
        clientError(e);
      });
      return true;
    };
  };

  const [clickedShareButton, setClickedShareButton] = useState(false);

  const handleShareClick = getShareFunction(
    shareTitle,
    shareDescription,
    shareUrl
  );

  const shareButton = () => {
    return (
      <Button
        onClick={(e) => {
          logEvent();
          if (!supportsShare) {
            e.target.blur();
            setClickedShareButton(true);
            setTimeout(() => {
              setClickedShareButton(false);
            }, 1000);
          }
          handleShareClick();
        }}
        size={size || constants.SMALL}
        strong={withText}
        circle={!withText}
        iconBefore={
          clickedShareButton ? (
            <TickIcon size={constants.MEDIUM} />
          ) : (
            <ShareIcon size={constants.MEDIUM} />
          )
        }
      >
        {withText && <FormattedMessage {...messages.shareText} />}
      </Button>
    );
  };

  return (
    <FormattedMessage {...messages.copied}>
      {(toolTipText) => {
        return (
          <CopyToClipboard text={shareUrl}>
            <Tooltip
              accessibleTitle={toolTipText}
              open={clickedShareButton}
              trigger={() => {
                return shareButton();
              }}
            >
              <Text type="caption">{toolTipText}</Text>
            </Tooltip>
          </CopyToClipboard>
        );
      }}
    </FormattedMessage>
  );
};

ShareButton.propTypes = {
  logEvent: PropTypes.func,
  shareTitle: PropTypes.string.isRequired,
  size: PropTypes.string,
  shareDescription: PropTypes.string.isRequired,
  shareUrl: PropTypes.string.isRequired,
  withText: PropTypes.bool,
};

ShareButton.defaultProps = {
  logEvent: () => {},
  size: constants.SMALL,
  withText: false,
};

export default ShareButton;
